module.exports = __webpack_public_path__ + "static/media/f2.3029405e.webp";